// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import ahoy from "ahoy.js"
import ApexCharts from "apexcharts"
import { _ } from "lodash"
import "mapkick/bundle"
import { buildChart, buildTooltip } from "preline/dist/helper-apexcharts.js"
import "preline/dist/preline.js"
import "./controllers"

ahoy.configure({cookies: false})

document.addEventListener("turbo:load", (event) => {
  HSAccordion.autoInit()
  HSDropdown.autoInit()
  HSOverlay.autoInit()
  HSSelect.autoInit()
  HSTabs.autoInit()
  HSCollapse.autoInit()
  HSTextareaAutoHeight.autoInit()
})

Turbo.config.forms.mode = "optin"

window._ = _
window.ApexCharts = ApexCharts
window.buildChart = buildChart
window.buildTooltip = buildTooltip

import "./hacks/charts"
import "./hacks/toasts"

